/**
 * @deprecated
 * @todo Safely depricate this composable, since we are now handling preview directly within TeaserPreview.vue
 */

import { h, createApp } from "vue"
import TeaserPreview from "../components/video/TeaserPreview.vue"
import { Movie } from "../types/Movie"
import { Series } from "../types/Series"
import { isNativeDevice } from "../helper"
import vueSpatialNavigation from "vue-spatial-nav"
import { globalConfig } from "../main"
import PrimeVue from "primevue/config"
import Aura from "@primevue/themes/aura"
import Tooltip from "primevue/tooltip"
import { useTeaserStore } from "../stores/teaser"
export interface TeaserPreviewOptions {
	item: Movie | Series
	teaserSize?: string
	src?: string
	onPreviewEnded?: () => void
}

/**
 * A composable function to replicate a teaser element for previewing.
 * @returns An object containing the replicateElement function.
 */
export function useTeaserPreview() {
	const teaserStore = useTeaserStore()
	const replicateElement = (originalElement: HTMLElement, options: TeaserPreviewOptions) => {
		const { item, teaserSize, onPreviewEnded } = options

		const existingReplica = document.querySelector(".teaser-replica")
		if (existingReplica && existingReplica.parentNode) {
			return
		}

		// Get the position and dimensions of the original element
		const rect = originalElement.getBoundingClientRect()

		// Detect if element is at the edge of the viewport
		const viewportWidth = window.innerWidth
		const distanceFromLeft = rect.left
		const distanceFromRight = viewportWidth - rect.right

		// Determine position class based on proximity to edges
		let positionClass = ""
		if (distanceFromLeft < 100) {
			positionClass = "is-first" // Near left edge
		} else if (distanceFromRight < 100) {
			positionClass = "is-last" // Near right edge
		}

		teaserStore.state.positionClass = positionClass
		// // Create a new div
		// const replicatedDiv = document.createElement("div")
		// replicatedDiv.classList.add("teaser")
		// replicatedDiv.classList.add("teaser-replica")

		// // Add teaser size class if provided
		// if (teaserSize) {
		// 	const sizeClass = teaserSize.replace("teaser_", "teaser-")
		// 	replicatedDiv.classList.add(sizeClass)
		// }

		// if (positionClass) {
		// 	replicatedDiv.classList.add(positionClass)
		// }
		// // Style the new div to match the original element
		// replicatedDiv.style.position = "absolute"
		// replicatedDiv.style.top = `${rect.top + window.scrollY}px`
		// replicatedDiv.style.left = `${rect.left + window.scrollX}px`
		// replicatedDiv.style.width = `${rect.width}px`
		// replicatedDiv.style.height = `${rect.height}px`

		// const tempDiv = document.createElement("div")
		// tempDiv.id = "teaser-preview-temp-div"
		// const app = createApp({
		// 	render: () =>
		// 		h(TeaserPreview, {
		// 			movie: item, // Pass the item prop (works for both Movie and Series)
		// 			isPreviewing: true,
		// 			isSubComponent: true,
		// 			teaserSize: teaserSize,
		// 		}),
		// })
		// app.use(vueSpatialNavigation, globalConfig)
		// app.use(PrimeVue, {
		// 	theme: {
		// 		preset: Aura,
		// 	},
		// })
		// app.directive("tooltip", Tooltip)
		// app.mount(tempDiv)

		// replicatedDiv.appendChild(tempDiv.firstElementChild as HTMLElement)
		// document.body.appendChild(replicatedDiv)
		// replicatedDiv.tabIndex = 0
		// replicatedDiv.focus()

		// // Add animation class only on web devices
		// if (!isNativeDevice) {
		// 	setTimeout(() => {
		// 		replicatedDiv.classList.add("is-previewing")
		// 		if (window.kwikMotion && window.kwikMotion("kwik-player-preview")) {
		// 			window.kwikMotion("kwik-player-preview").dispose()
		// 		}
		// 	}, 100)
		// }

		// // Handle mouseleave (web devices)
		// if (!isNativeDevice) {
		// 	replicatedDiv.addEventListener("mouseleave", () => {
		// 		// replicatedDiv.classList.remove("is-previewing")
		// 		// replicatedDiv.classList.add("is-closing")

		// 		// if (onPreviewEnded) {
		// 		// 	onPreviewEnded()
		// 		// }

		// 		setTimeout(() => {
		// 			if (replicatedDiv.parentNode) {
		// 				// document.body.removeChild(replicatedDiv)
		// 			}
		// 		}, 500)
		// 	})
		// }

		// // Handle blur (native devices)
		// if (isNativeDevice) {
		// 	replicatedDiv.addEventListener("blur", () => {
		// 		console.log("replicated div blurred")

		// 		if (onPreviewEnded) {
		// 			onPreviewEnded()
		// 		}

		// 		setTimeout(
		// 			() => {
		// 				if (replicatedDiv.parentNode) {
		// 					document.body.removeChild(replicatedDiv)
		// 				}
		// 			},
		// 			isNativeDevice ? 0 : 500
		// 		)
		// 	})
		// }
	}

	/**
	 * Removes any existing replicated teaser element from the DOM.
	 */
	const removeReplicatedElement = (): void => {
		const existingReplica = document.querySelector(".teaser-replica")
		if (existingReplica && existingReplica.parentNode) {
			document.body.removeChild(existingReplica)
		}
	}

	return {
		replicateElement,
		removeReplicatedElement,
	}
}
